import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";

// Import Model
import { apiLink } from "../../../constant/api-link";
import { LocalStorageService } from "angular-2-local-storage";
import { SaleTransactionListModel, SaleTransactionListQueryModel } from "../../../model/builk/package-sale/sale-transaction.model";
import { ProjectTransactionInvoiceDetailModel } from "../../../model/builk/package-sale/create-request-invoice.model";
import { SaleCustomCostcodeTransactionListModel, SaleCustomCostcodeTransactionListQueryModel } from "../../../model/builk/custom-costcode-sale/sale-custom-costcode-transaction.model";
import { CreateQuotationPackageModel, QuotationPackageResponseModel } from "../../../model/builk/package-sale/create-quotation-package.model";
import { ResponseModel } from "../../../model/builk/response.model";
import { ApprovePayProjectTransactionModel } from "../../../model/builk/package-sale/approve-pay-project-transaction.model";

@Injectable({
  providedIn: "root"
})
export class PackageSaleService {

  constructor(
    private http: HttpClient,
    private localStorageService: LocalStorageService
  ) { }

  sub: any;

  getSaleTransaction(query: SaleTransactionListQueryModel): Observable<SaleTransactionListModel> {
    const url = apiLink.getSaleTransaction;
    let params = new HttpParams()
      .set("PageNumber", query.pageNumber.toString())
      .set("PageSize", query.pageSize.toString())
      .set("SortByDesc", query.sortByDesc.toString())
      .set("SortColumn", query.sortColumn.toString());

    if (query.textSearch !== undefined && query.textSearch !== null && query.textSearch !== '') {
      params = params.append("TextSearch", query.textSearch.toString());
    }

    if (query.status !== undefined && query.status !== null) {
      params = params.append("Status", query.status.toString());
    }

    if (query.startDate !== undefined && query.startDate !== null) {
      params = params.append("StartDate", query.startDate.toISOString());
    }

    if (query.endDate !== undefined && query.endDate !== null) {
      params = params.append("EndDate", query.endDate.toISOString());
    }
    return this.http.get<SaleTransactionListModel>(url, { params: params });
  }

  exportSaleTransaction(query: SaleTransactionListQueryModel): Observable<Blob> {
    const url = apiLink.exportSaleTransaction;

    let body = {
      sortByDesc: query.sortByDesc,
      sortColumn: query.sortColumn
    };
    if (query.startDate !== undefined && query.startDate !== null) {
      body['startDate'] = query.startDate.toISOString();
    }

    if (query.endDate !== undefined && query.endDate !== null) {
      body['endDate'] = query.endDate.toISOString();
    }
    const headers = new HttpHeaders({ "Content-Type": "application/json" });
    return this.http.post<Blob>(url, body, { responseType: 'blob' as 'json', headers: headers });
  }

  getProjectTransactionInvoiceDetail(refId: string): Observable<ProjectTransactionInvoiceDetailModel> {
    const url = apiLink.getProjectTransactionInvoiceDetail;
    const params = new HttpParams()
      .set("refId", refId);

    return this.http.get<ProjectTransactionInvoiceDetailModel>(url, { params });
  }

  getCustomCostcodeTransactionInvoiceDetail(refId: string): Observable<ProjectTransactionInvoiceDetailModel> {
    const url = apiLink.getCustomCostcodeTransactionInvoiceDetail;
    const params = new HttpParams()
      .set("refId", refId);

    return this.http.get<ProjectTransactionInvoiceDetailModel>(url, { params });
  }

  getCustomCostcodeSaleTransaction(query: SaleCustomCostcodeTransactionListQueryModel): Observable<SaleCustomCostcodeTransactionListModel> {
    const url = apiLink.getSaleCustomCostcodeTransaction;
    let params = new HttpParams()
      .set("PageNumber", query.pageNumber.toString())
      .set("PageSize", query.pageSize.toString())
      .set("SortByDesc", query.sortByDesc.toString())
      .set("SortColumn", query.sortColumn.toString());

    if (query.textSearch !== undefined && query.textSearch !== null && query.textSearch !== '') {
      params = params.append("TextSearch", query.textSearch.toString());
    }

    if (query.status !== undefined && query.status !== null) {
      params = params.append("Status", query.status.toString());
    }

    if (query.startDate !== undefined && query.startDate !== null) {
      params = params.append("StartDate", query.startDate.toISOString());
    }

    if (query.endDate !== undefined && query.endDate !== null) {
      params = params.append("EndDate", query.endDate.toISOString());
    }
    return this.http.get<SaleCustomCostcodeTransactionListModel>(url, { params: params });
  }

  exportSaleCustomCostcodeTransaction(query: SaleCustomCostcodeTransactionListQueryModel): Observable<Blob> {
    const url = apiLink.exportSaleCustomCostcodeTransaction;

    let body = {
      sortByDesc: query.sortByDesc,
      sortColumn: query.sortColumn
    };
    if (query.startDate !== undefined && query.startDate !== null) {
      body['startDate'] = query.startDate.toISOString();
    }

    if (query.endDate !== undefined && query.endDate !== null) {
      body['endDate'] = query.endDate.toISOString();
    }
    const headers = new HttpHeaders({ "Content-Type": "application/json" });
    return this.http.post<Blob>(url, body, { responseType: 'blob' as 'json', headers: headers });
  }

  createQuotationPackage(model: CreateQuotationPackageModel): Observable<ResponseModel<QuotationPackageResponseModel>> {
    const url = apiLink.createQuotationPackage;
    return this.http.post<ResponseModel<QuotationPackageResponseModel>>(url, model);
  }

  approvePayProjectTransaction(model: ApprovePayProjectTransactionModel): Observable<ResponseModel<boolean>> {
    const url = apiLink.approvePayProjectTransaction;
    return this.http.post<ResponseModel<boolean>>(url, model);
  }
}
